export default "__VITE_ASSET__CoY$09k5__"